import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { APP_VERSION, BASE_URL, ENV_SITE_DEV } from '../../constants';
import { useDispatch, useSelector } from 'react-redux';
import { setCurrentPage, setSidebarState } from './../../redux/generalSlice';
import { resetAuthState } from '../../redux/authSlice';
import TestSite from '../TestSite';
import { ThemeProvider, Tooltip, createTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useMsal } from "@azure/msal-react";
import Redirect from '../components/Redirect';
import Notifications from '../components/Notifications';

const customTheme = createTheme({
  palette: {
    primary: {
      main: "#B11116",
      contrastText: "white",
    },
  },
});

const BackendLayout = ({ children }) => {

  const { instance } = useMsal();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const sidebarOpened = useSelector((s) => s.general.sidebarOpened);
  const currentPage = useSelector((s) => s.general.currentPage);
  const siteLanguage = useSelector((s) => s.general.siteLanguage);
  const authData = useSelector((s) => s.auth.data);
  const { t } = useTranslation();

  useEffect(() => {
    document.getElementById("root").classList.remove("w-100");
    document.getElementById("root").classList.add("d-flex");
    document.getElementById("root").classList.add("flex-grow-1");
    window.KTToggle.init();
    window.KTScroll.init();
  }, []);

  useEffect(() => {
    document.getElementById("kt_app_body").dataset.ktAppSidebarMinimize = !sidebarOpened ? "on" : "";
  }, [sidebarOpened]);

  const handleLogout = () => {
    if (window.confirm(t("711", "You are about to logout from eRespiroConnect. Are you sure?"))) {
      if (authData.user_type > 0) {
        dispatch(resetAuthState());
        instance.logoutRedirect({
          onRedirectNavigate: (url) => {
            return false;
          }
        });
      }
      dispatch(resetAuthState());
      navigate('/login');
    }
  }

  return authData.id != '' ? (
    <ThemeProvider theme={customTheme}>
      <link rel="stylesheet" href={`${BASE_URL}/assets/css/backend.css`} />
      <link
        rel="stylesheet"
        href="https://fonts.googleapis.com/css?family=Inter:300,400,500,600,700"
      />
      <div className="d-flex flex-column flex-root app-root" id="kt_app_root">
        <div
          className="app-page flex-column flex-column-fluid"
          id="kt_app_page"
        >
          <div id="kt_app_header" className="app-header">
            <div
              className="w-100 d-flex align-items-stretch justify-content-between"
              id="kt_app_header_container"
            >
              <div
                className="d-flex align-items-center d-lg-none ms-n3 me-1 me-md-2"
                title="Show sidebar menu"
              >
                <button
                  className="btn btn-icon btn-active-color-primary w-35px h-35px"
                  id="kt_app_sidebar_mobile_toggle"
                  onClick={() => dispatch(setSidebarState(!sidebarOpened))}
                >
                  <span className="svg-icon svg-icon-2 svg-icon-md-1">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M21 7H3C2.4 7 2 6.6 2 6V4C2 3.4 2.4 3 3 3H21C21.6 3 22 3.4 22 4V6C22 6.6 21.6 7 21 7Z"
                        fill="currentColor"
                      ></path>
                      <path
                        opacity="0.3"
                        d="M21 14H3C2.4 14 2 13.6 2 13V11C2 10.4 2.4 10 3 10H21C21.6 10 22 10.4 22 11V13C22 13.6 21.6 14 21 14ZM22 20V18C22 17.4 21.6 17 21 17H3C2.4 17 2 17.4 2 18V20C2 20.6 2.4 21 3 21H21C21.6 21 22 20.6 22 20Z"
                        fill="currentColor"
                      ></path>
                    </svg>
                  </span>
                </button>
              </div>
              <div className="header d-flex py-1 w-100 ps-4">
                <div className="header-left mr-auto d-flex flex-grow-1 py-2">
                  <h4 className="ms-5 border border-left-0 border-right-0 border-top-0 border-bottom-0 border-white my-auto fw-normal align-middle text-uppercase">
                    eRespiroConnect
                  </h4>
                </div>
                <div className="header-right">
                  <div
                    className="app-navbar-item"
                    id="kt_header_user_menu_toggle"
                  >
                    <div
                      className="d-flex"
                      data-kt-menu-trigger="{default: 'click', lg: 'hover'}"
                      data-kt-menu-attach="parent"
                      data-kt-menu-placement="bottom-end"
                    >
                      <div className="text-end d-none d-sm-flex flex-column justify-content-start me-1 py-2">
                        <span className="align-self-end lead text-white">
                          {authData?.name ?? "User Name"}
                        </span>
                      </div>
                      <div className="text-center">
                        <div className="border border-1 cursor-pointer symbol symbol symbol-circle symbol-35px mb-2">
                          <img
                            className="rounded-circle h-75"
                            src={`${BASE_URL}/assets/icons/avatar.png`}
                            alt="user"
                          />
                        </div>
                        <div className="h-15px">
                          <Notifications />

                          <Tooltip title={t("716", "Settings")}>
                            <Link
                              to='/portal/profile'
                              className='mx-1 h-15px d-inline-block'
                            >
                              <img
                                className="align-top"
                                src={`${BASE_URL}/assets/icons/icons8-gear-16.png`}
                              />
                            </Link>
                          </Tooltip>

                          <Tooltip title={t("717", "Logout")}>
                            <a
                              href="#"
                              className='mx-1 h-15px d-inline-block'
                              onClick={e => (e.preventDefault(), handleLogout())}
                            >
                              <img
                                className="align-top"
                                src={`${BASE_URL}/assets/icons/icons8-power-48.png`}
                                width="15"
                                height="15"
                              />
                            </a>
                          </Tooltip>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className="d-flex align-items-stretch justify-content-between flex-lg-grow-1"
                id="kt_app_header_wrapper"
              >
                <div
                  className="app-header-menu app-header-mobile-drawer align-items-stretch"
                  data-kt-drawer="true"
                  data-kt-drawer-name="app-header-menu"
                  data-kt-drawer-activate="{default: true, lg: false}"
                  data-kt-drawer-overlay="true"
                  data-kt-drawer-width="250px"
                  data-kt-drawer-direction="end"
                  data-kt-drawer-toggle="#kt_app_header_menu_toggle"
                  data-kt-swapper="true"
                  data-kt-swapper-mode="{default: 'append', lg: 'prepend'}"
                  data-kt-swapper-parent="{default: '#kt_app_body', lg: '#kt_app_header_wrapper'}"
                ></div>
              </div>
            </div>
          </div>
          <div
            className="app-wrapper flex-column flex-row-fluid"
            id="kt_app_wrapper"
          >
            <div
              id="kt_app_sidebar"
              className="app-sidebar side-bar-theme flex-column"
              data-kt-drawer="true"
              data-kt-drawer-name="app-sidebar"
              data-kt-drawer-activate="{default: true, lg: false}"
              data-kt-drawer-overlay="true"
              data-kt-drawer-width="225px"
              data-kt-drawer-direction="start"
              data-kt-drawer-toggle="#kt_app_sidebar_mobile_toggle"
            >
              <div
                className="app-sidebar-logo px-6"
                id="kt_app_sidebar_logo"
                style={{ borderBottom: "#fff, solid" }}
              >
                <div className="container text-center" id="kt_app_sidebar_logo">
                  <img
                    className="img-fluid app-sidebar-logo-default"
                    style={{ height: "50px", width: "auto" }}
                    src={`${''}`}
                    alt=""
                  />
                  <img
                    className="app-sidebar-logo-minimize img-fluid w-auto p-0 m-0"
                    src={`${''}`}
                    style={{ maxHeight: "60px", width: "100%" }}
                    alt=""
                  />
                  {/* <img
                    src={`${BASE_URL}/assets/images/CL-logo-small.png`}
                    className="h-40px app-sidebar-logo-minimize img-fluid w-auto"
                    style={{ height: "50px", width: "auto" }}
                    alt=""
                  /> */}
                </div>
                <button
                  id="kt_app_sidebar_toggle"
                  className="app-sidebar-toggle btn btn-icon btn-shadow btn-sm btn-color-muted btn-active-color-primary body-bg h-30px w-30px position-absolute top-50 start-100 translate-middle rotate"
                  data-kt-toggle="true"
                  data-kt-toggle-state="active"
                  data-kt-toggle-target="body"
                  data-kt-toggle-name="app-sidebar-minimize"
                  onClick={() => dispatch(setSidebarState(!sidebarOpened))}
                >
                  <span className="svg-icon svg-icon-2 rotate-180">
                    <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        opacity="0.5"
                        d="M14.2657 11.4343L18.45 7.25C18.8642 6.83579 18.8642 6.16421 18.45 5.75C18.0358 5.33579 17.3642 5.33579 16.95 5.75L11.4071 11.2929C11.0166 11.6834 11.0166 12.3166 11.4071 12.7071L16.95 18.25C17.3642 18.6642 18.0358 18.6642 18.45 18.25C18.8642 17.8358 18.8642 17.1642 18.45 16.75L14.2657 12.5657C13.9533 12.2533 13.9533 11.7467 14.2657 11.4343Z"
                        fill="currentColor"
                      />
                      <path
                        d="M8.2657 11.4343L12.45 7.25C12.8642 6.83579 12.8642 6.16421 12.45 5.75C12.0358 5.33579 11.3642 5.33579 10.95 5.75L5.40712 11.2929C5.01659 11.6834 5.01659 12.3166 5.40712 12.7071L10.95 18.25C11.3642 18.6642 12.0358 18.6642 12.45 18.25C12.8642 17.8358 12.8642 17.1642 12.45 16.75L8.2657 12.5657C7.95328 12.2533 7.95328 11.7467 8.2657 11.4343Z"
                        fill="currentColor"
                      />
                    </svg>
                  </span>
                </button>
              </div>
              <div className="app-sidebar-menu overflow-hidden flex-column-fluid">
                <div
                  id="kt_app_sidebar_menu_wrapper"
                  className="app-sidebar-wrapper hover-scroll-overlay-y my-5 d-flex flex-column"
                  data-kt-scroll="true"
                  data-kt-scroll-activate="true"
                  data-kt-scroll-height="auto"
                  data-kt-scroll-dependencies="#kt_app_sidebar_logo, #kt_app_sidebar_footer"
                  data-kt-scroll-wrappers="#kt_app_sidebar_menu"
                  data-kt-scroll-offset="5px"
                  data-kt-scroll-save-state="true"
                >
                  <div
                    className="menu menu-column menu-rounded menu-sub-indention"
                    id="#kt_app_sidebar_menu"
                    data-kt-menu="true"
                    data-kt-menu-expand="false"
                  >
                    <div className="menu-item">
                      <Link
                        className={`menu-link ${currentPage == "dashboard" ? "active" : ""
                          }`}
                        to={"/portal"}
                        style={{
                          borderRadius: "0%",
                          marginLeft: "0%",
                          marginRight: "0%",
                        }}
                      >
                        <span className="menu-icon">
                          <i className="fas fa-home"></i>
                        </span>
                        <span className="menu-title ">
                          {t("0", "Dashboard")}
                        </span>
                      </Link>
                    </div>
                    <hr />
                    <div className="menu-item">
                      <Link
                        className={`menu-link ${currentPage == "country-profile" ? "active" : ""
                          }`}
                        to={"/portal/country-profile"}
                        style={{
                          borderRadius: "0%",
                          marginLeft: "0%",
                          marginRight: "0%",
                        }}
                      >
                        <span className="menu-icon">
                          <i className="fa-solid fa-globe"></i>
                        </span>
                        <span className="menu-title ">
                          Country Profile
                        </span>
                      </Link>
                    </div>
                    <div className="menu-item">
                      <Link
                        className={`menu-link ${currentPage == "reports-module" ? "active" : ""
                          }`}
                        to={"/portal/reports"}
                        style={{
                          borderRadius: "0%",
                          marginLeft: "0%",
                          marginRight: "0%",
                        }}
                      >
                        <span className="menu-icon">
                          <i className="fa-solid fa-file"></i>
                        </span>
                        <span className="menu-title ">
                          Reports
                        </span>
                      </Link>
                    </div>
                    <div className="menu-item">
                      <Link
                        className={`menu-link ${currentPage == "wages-module" ? "active" : ""
                          }`}
                        to={"/portal/minimum-wage-rates"}
                        style={{
                          borderRadius: "0%",
                          marginLeft: "0%",
                          marginRight: "0%",
                        }}
                      >
                        <span className="menu-icon">
                          <i className="fa-solid fa-scale-unbalanced-flip"></i>
                        </span>
                        <span className="menu-title ">
                          Minimum Wage Rates
                        </span>
                      </Link>
                    </div>
                    <div className="menu-item">
                      <Link
                        className={`menu-link ${currentPage == "update-wage-rates" ? "active" : ""
                          }`}
                        to={"/portal/update-wage-rates"}
                        style={{
                          borderRadius: "0%",
                          marginLeft: "0%",
                          marginRight: "0%",
                        }}
                        disabled={true}
                      >
                        <span className="menu-icon">
                          <i className="fa-solid fa-scale-unbalanced-flip"></i>
                        </span>
                        <span className="menu-title ">
                          Update Wage Rates
                        </span>
                      </Link>
                    </div>
                    <hr />
                    <div className="menu-item">
                      <Link
                        className={`menu-link ${currentPage == "metadata-management" ? "active" : ""
                          }`}
                        to={"/portal/metadata-management"}
                        style={{
                          borderRadius: "0%",
                          marginLeft: "0%",
                          marginRight: "0%",
                        }}
                      >
                        <span className="menu-icon">
                          <span className="svg-icon svg-icon-2">
                            <img
                              src={`${BASE_URL}/assets/icons/v2.png`}
                              width="17px"
                              height="17px"
                              viewBox="0 0 24 24"
                              version="1.1"
                            />
                          </span>
                        </span>
                        <span className="menu-title">
                          {t("-1", "Metadata Management")}
                        </span>
                      </Link>
                    </div>
                    <div className="menu-item">
                      <Link
                        className={`menu-link ${currentPage == "user-management" ? "active" : ""
                          }`}
                        to={"/portal/user-management"}
                        style={{
                          borderRadius: "0%",
                          marginLeft: "0%",
                          marginRight: "0%",
                        }}
                      >
                        <span className="menu-icon">
                          <i className="fa-solid fa-user"></i>
                        </span>
                        <span className="menu-title">
                          {t("7", "User Management")}
                        </span>
                      </Link>
                    </div>
                    <div className="menu-item">
                      <Link
                        className={`menu-link ${currentPage == "role-management" ? "active" : ""
                          }`}
                        to={"/portal/role-management"}
                        style={{ borderRadius: '0%', marginLeft: '0%', marginRight: '0%' }}
                      >
                        <span className="menu-icon">
                          <i className="fa-solid fa-users"></i>
                        </span>
                        <span className="menu-title">{t("824", "Role Management")}</span>
                      </Link>
                    </div>
                    {/* <hr /> */}
                    {/* <div className="menu-item">
                      <Link
                        className={`menu-link ${currentPage == "multilingual-keywords" ? "active" : ""
                          }`}
                        to="/portal/multilingual-keywords"
                        style={{
                          borderRadius: "0%",
                          marginLeft: "0%",
                          marginRight: "0%",
                        }}
                      >
                        <span className="menu-icon">
                          <i className="fas fa-language"></i>
                        </span>
                        <span className="menu-title">
                          {t("12", "Multilingual Keywords")}
                        </span>
                      </Link>
                    </div> */}
                    <hr />
                    <div className="menu-item">
                      <Link
                        className={`menu-link ${currentPage == "system-status" ? "active" : ""
                          }`}
                        to="/portal/system-status"
                        style={{
                          borderRadius: "0%",
                          marginLeft: "0%",
                          marginRight: "0%",
                        }}
                      >
                        <span className="menu-icon">
                          <i className="fas fa-plug"></i>
                        </span>
                        <span className="menu-title">
                          {t("11", "System Status")}
                        </span>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="app-main flex-column flex-row-fluid"
              id="kt_app_main"
            >
              {/* {ENV_SITE_DEV && <TestSite />} */}
              <div className="px-4 py-1">
                {children}
                <div className="d-flex flex-column flex-column-fluid">
                  <div
                    id="kt_app_content"
                    className="app-content flex-column-fluid"
                  >
                    <div
                      id="kt_app_content_container"
                      className="app-container container-fluid"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ThemeProvider>
  ) : (
    <Redirect to='/login' passCurrentRoute={true} />
  );
};

export default BackendLayout;
